const theme = {
  en: {
    label: 'Display theme',
    light: 'Clear Blue',
    dark: 'Brown Gold',
    deviceHint: 'Saved on this device, even after you sign out.',
  },
  ko: {
    label: '화면 테마',
    light: '클리어 블루',
    dark: '브라운 골드',
    deviceHint: '로그아웃 후에도 이 기기에 선택한 테마가 유지됩니다.',
  },
};

export default theme;
